export function getInventorySearchFilter({ contentVehicle, isInternational }) {
  return {
    ...(isInternational ? { national: true } : {}),
    ...(contentVehicle?.make ? { make: [contentVehicle.make] } : {}),
    ...(contentVehicle?.make && contentVehicle?.model
      ? { model: [`${contentVehicle.make}|${contentVehicle.model}`] }
      : {}),
    pageSize: 3,
  };
}
